export const defaultTinyMceConfig = {
    plugins: 'lists advlist',
    toolbar: 'undo redo | bold italic underline | bullist numlist'
};

export const smallTinyMceConfig = {
    toolbar: 'undo redo | bold italic'
};